import {KeyValuePipe} from '@angular/common'
import {Component, input} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {MatOption} from '@angular/material/autocomplete'
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatSelect} from '@angular/material/select'
import {sortOriginal} from '@sparbanken-syd/sparbanken-syd-theme'
import {BaseComponent} from '../base.component'

@Component({
  selector: 'spb-occupation',
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    KeyValuePipe,
    MatOption,
    MatSelect,
    MatError,
    MatIcon,
    MatSuffix
  ],
  templateUrl: './occupation.component.html',
  providers: [{provide: BaseComponent, useExisting: OccupationComponent}]
})
/**
 * Occupation is not set directly in any model.
 */
export class OccupationComponent extends BaseComponent {
  public override debugName = 'occupation'
  // Simple key value list of occupations to select.
  public occupations = input.required<Map<string, string>>()
  protected readonly sortOriginal = sortOriginal
}
